import { Component, NgZone, inject, input } from '@angular/core';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import {filter, first, map} from 'rxjs/operators';
import { GameProvider, GameProvidersService } from 'src/app/core/services/games/game-providers.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { StaticContentService } from 'src/app/core/services/static-content.service';
import { BankingService } from 'src/app/core/services/banking.service';
import { ArrayService } from 'src/app/core/services/array.service';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { UserPaymentModeService } from '../../../services/user/user-payment-mode.service';
import { OffersService } from '../../../services/offers.service';
import { SeoService } from '../../../services/seo.service';
import { AccordionButtonComponent } from '../../components/accordion-button/accordion-button.component';
import { ClassLoadedDirective, DeleteNotFoundDirective, ImgDimensionDirective } from 'ngx-unificator/directives';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { SafePipe } from 'ngx-unificator/pipes';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        AccordionButtonComponent,
        AsyncPipe,
        DeleteNotFoundDirective,
        ImgDimensionDirective,
        ClassLoadedDirective,
        TranslatePipe,
        SafePipe,
        RouterLink,
        NgTemplateOutlet,
    ]
})
export class FooterComponent {
  user = inject(UserService);
  banking = inject(BankingService);
  seo = inject(SeoService);
  paymentMode = inject(UserPaymentModeService);
  private _staticContent = inject(StaticContentService);
  private _gameProviders = inject(GameProvidersService);
  private _array = inject(ArrayService);
  private _offer = inject(OffersService);


  public paymentList$: Observable<any> = combineLatest([
    this.banking.depositPaymentList$,
    this.banking.withdrawalPaymentList$,
  ]).pipe(
    map(([dep, cash]) => this._array.uniqueBy('id', [...dep, ...cash])),
  );

  /**
   * Social Footer content from CMS
   */
  public social$ = this._offer.item({ slug: '21bit-social-promo' });

  /**
   * Pass true if you want hide license text and logos
   */
  readonly hideText = input<boolean>(undefined);

  /**
   * Copyright text from CMS
   */
  public copyright$: ReplaySubject<any> = this._staticContent.item({ slug: 'footer-copyright' });

  /**
   * List of game providers
   */
  public providerList$: ReplaySubject<GameProvider[]> = this._gameProviders.list$.pipe(
    map((list) => {
      const playson = list.find((e) => e?.alias === 'playson_infin');
      playson ? playson.alias = 'playson' : null;
      return list;
    }),
    map(list => list.filter(e => e.inFooter)),
  ) as ReplaySubject<GameProvider[]>;

  /**
   * License logo
   */
  public license$: Observable<{Img: string; Url: string;}> = this._staticContent.item({ slug: '21bit-license-static' }).pipe(
    filter(data => !!data?.[0]),
    first(),
    map(data => data?.[0]),
  );
}
